module.exports = __webpack_public_path__ + "static/media/used-tires.d4846095.svg";